import {type LexiconDoc} from '@atproto/lexicon'

// Backend updated this from a query (GET) to a procedure (POST).
// Override the stale SDK lexicon until the @atproto/api package is updated.
export const getSuggestedOnboardingUsers: LexiconDoc = {
  lexicon: 1,
  id: 'app.bsky.unspecced.getSuggestedOnboardingUsers',
  defs: {
    main: {
      type: 'procedure',
      input: {
        encoding: 'application/json',
      },
    },
  },
}
